<template>
    <div id="container">
        <Spinner :show="loading"></Spinner>
        <Header></Header>
        <Modal v-if="modal.title" :title="modal.title" :body="modal.body" :centerBody="modal.centerBody" :className="modal.className" :buttons="modal.buttons"></Modal>
        <section ref="content" id="content" class="section has-text-centered relative">
            <Notification v-if="notification.show" :text="notification.text" :className="notification.className"></Notification>
            <AddTag ref="addTagModal"></AddTag>
            <div ref="step1" class="absolute">
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <div class="control has-icons-left">
                            <div class="select is-fullwidth">
                                <div class="select is-fullwidth">
                                    <select ref="callingCode" v-model="household.callingCode">
                                        <option disabled value="disabled">{{ $t("Country")}}</option>
                                        <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                    </select>
                                </div>
                            </div>
                            <div class="icon is-small is-left">
                                <i class="fa fa-globe"></i>
                            </div>
                        </div>
                    </div>
                    <div class="column is-half">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input ref="mobile" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="household.mobile" autocomplete="off" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-phone"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                    </div>
                    <div class="column is-half">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step2" class="absolute is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input ref="name" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" :placeholder="$t('HouseholdName')" v-model="household.name" autocomplete="off" required>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-home"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                    <div class="column is-half">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step3" class="absolute is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input ref="address" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input" type="text" :placeholder="$t('Address')" v-model="household.address" autocomplete="off">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-map-marker"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                    <div class="column is-half">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step4" class="absolute is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <div class="control has-icons-left">
                            <div class="select is-fullwidth">
                                <select ref="waterSystem" @change="updateTaps()" v-model="household.systemID" required>
                                    <option disabled value="disabled">{{ $t("WaterSystem")}}</option>
                                    <option v-for="waterSystem in waterSystems" :key="waterSystem.waterSystemID" :value="waterSystem.waterSystemID">{{ waterSystem.name }}</option>
                                </select>
                            </div>
                            <div class="icon is-small is-left">
                                <i class="fa fa-tint"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-full">
                        <div class="control has-icons-left">
                            <div class="select is-fullwidth">
                                <select ref="asset" v-model="household.assetID" required>
                                    <option disabled value="disabled">{{ $t("Tap")}}</option>
                                    <option v-for="asset in assets" :key="asset.assetID" :value="asset.assetID" class="status">{{ asset.name }} ({{ asset.connected ? "Online" : "Offline" }})</option>
                                </select>
                            </div>
                            <div class="icon is-small is-left">
                                <i class="fa fa-tint"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                    <div class="column is-half">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step5" class="absolute is-hidden">
                <div class="columns is-mobile is-centered">
                    <div class="column has-text-centered">
                        {{ $t("Age") }}
                    </div>
                    <div class="column has-text-centered">
                        {{ $t("Males") }}
                    </div>
                    <div class="column has-text-centered">
                        {{ $t("Females") }}
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column has-text-centered" style="padding-top: 20px">
                        0-11
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.m1" @click="hideTabs(); if(household.stats.m1 == 0){household.stats.m1 = null}" @focus="hideTabs(); if(household.stats.m1 == 0){household.stats.m1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.f1" @click="hideTabs(); if(household.stats.f1 == 0){household.stats.f1 = null}" @focus="hideTabs(); if(household.stats.f1 == 0){household.stats.f1 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column has-text-centered" style="padding-top: 20px">
                        11-18
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.m2" @click="hideTabs(); if(household.stats.m2 == 0){household.stats.m2 = null}" @focus="hideTabs(); if(household.stats.m2 == 0){household.stats.m2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.f2" @click="hideTabs(); if(household.stats.f2 == 0){household.stats.f2 = null}" @focus="hideTabs(); if(household.stats.f2 == 0){household.stats.f2 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column has-text-centered" style="padding-top: 20px">
                        18-65
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.m3" @click="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @focus="hideTabs(); if(household.stats.m3 == 0){household.stats.m3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.f3" @click="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @focus="hideTabs(); if(household.stats.f3 == 0){household.stats.f3 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column has-text-centered" style="padding-top: 20px">
                        65+
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.m4" @click="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @focus="hideTabs(); if(household.stats.m4 == 0){household.stats.m4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="column has-text-centered">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input v-model.number="household.stats.f4" @click="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @focus="hideTabs(); if(household.stats.f4 == 0){household.stats.f4 = null}" @blur="showTabs()" class="input" autocomplete="off" type="number" min="0">
                                <span class="icon is-small is-left">
                                    <i class="fa fa-user"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                        <a @click="back()" class="button is-info is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-left"></i>
                            </span>
                            <span>{{ $t("Back") }}</span>
                        </a>
                    </div>
                    <div class="column is-half">
                        <a @click="next()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-arrow-right"></i>
                            </span>
                            <span>{{ $t("Next") }}</span>
                        </a>
                    </div>
                </div>
            </div>
            <div ref="step6" class="absolute is-hidden">
                <p v-if="!tags.length">{{ $t("AddTagInfo") }}</p>
                <p v-else>{{ $t("AddTagInfo2") }}</p>
                <div v-for="tag in tags" :key="tag.nfcid" class="card">
                    <div class="card-content">
                        <div class="field">
                            <div class="control has-icons-left">
                                <input class="input" @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" :value="tag.nfcid" type="text" autocomplete="off" :placeholder="$t('TagID')" pattern="[A-Fa-f0-9]{8}" maxlength="8" required readonly>
                                <span class="icon is-small is-left">
                                    <i class="fa fa-tag"></i>
                                </span>
                            </div>
                        </div>
                        <div class="columns is-mobile is-centered">
                            <div class="column">
                                <div class="control has-icons-left">
                                    <div class="select is-fullwidth">
                                        <select v-model="tag.callingCode">
                                            <option disabled value="disabled">{{ $t("Country") }}</option>
                                            <option v-for="country in countries" :key="country.id" :value="country.callingCode">{{ country.name }} (+{{ country.callingCode }})</option>
                                        </select></div>
                                    <div class="icon is-small is-left"><i class="fa fa-globe"></i></div>
                                </div>
                            </div>
                            <div class="column">
                                <div class="field">
                                    <div class="control has-icons-left">
                                        <input @click="hideTabs()" @focus="hideTabs()" @blur="showTabs()" class="input no-spinner" type="number" :placeholder="$t('Mobile')" v-model="tag.mobile" min="0">
                                        <span class="icon is-small is-left">
                                            <i class="fa fa-phone"></i>
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <footer>
                        <div v-show="tag.removable" class="columns is-mobile has-text-centered">
                            <div class="column is-full">
                                <a @click="removeTag(tag.nfcid)" class="button is-danger is-fullwidth">
                                    <span class="icon">
                                        <i class="fa fa-times"></i>
                                    </span>
                                    <span>{{ $t("Remove") }}</span>
                                </a>
                            </div>
                        </div>
                    </footer>
                </div>
                <div class="column is-full has-text-centered">
                    <a @click="$refs.addTagModal.start()" class="has-text-weight-bold">
                        <span class="icon">
                            <i class="fa fa-plus-circle"></i>
                        </span> 
                        <span>{{ $t("AddTag") }}</span>
                    </a>
                </div>
                <div class="columns is-mobile is-centered">
                    <div class="column is-half">
                    </div>
                    <div v-show="tags.length" class="column is-half">
                        <a @click="save()" class="button is-primary is-fullwidth">
                            <span class="icon">
                                <i class="fa fa-save"></i>
                            </span>
                            <span>{{ $t("SaveChanges") }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </section>
        <NavigationTabs></NavigationTabs>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Modal from "@/components/Modal.vue";
import AddTag from "@/components/AddTag.vue";
import Notification from "@/components/Notification.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import Spinner from "@/components/Spinner.vue";

export default {
  name: "RegisterHousehold",
  components: {
    Header,
    Modal,
    AddTag,
    Notification,
    NavigationTabs,
    Spinner
  },
  async mounted()
  {
    this.household.callingCode = this.user.callingCode;
    this.household.mobile = this.user.mobile;
    await this.getWaterSystems();

    await navigator.geolocation.getCurrentPosition(position =>
    {
        if (position)
        {
            this.location = position.coords;
        }
    });
  },
  data () {
    return {
        tags: [],
        household:
        {
            id: null,
            name: null,
            stats: {
                m1: 0,
                m2: 0,
                m3: 0,
                m4: 0,
                f1: 0,
                f2: 0,
                f3: 0,
                f4: 0
            },
            callingCode: null,
            mobile: null,
            address: null,
            systemID: "disabled",
            assetID: "disabled"
        },
        numberInHousehold: 0,
        step: 1,
        assets: [],
        location: null,
        modal: {
          title: "eWater " + this.$t("Terms"),
          body: this.$t("RegisterCarbonOffsetTerms").replace(/{/g, '<').replace(/}/g, '>'),
          centerBody: false,
          className: "is-active",
          buttons: [
            {id: 0, title: this.$t("Accept"), className: "is-primary", click: () => {this.modal.className = "";}}
          ]
        }
    }
  },
  methods:
  {
    addTag: function(newTag)
    {
        for(const tag of this.tags)
        {
            if(tag.nfcid == newTag.nfcid)
            {
                alert(this.$t("TagAlreadyAdded"));
                return false;
            }
        }

        this.tags.push(newTag);
        return true;
    },
    removeTag: function(nfcid)
    {
        for(let i=0; i < this.tags.length; i++)
        {
            if(this.tags[i].nfcid == nfcid)
            {
                this.tags.splice(i, 1);
            }
        }
    },
    updateTaps: async function()
    {
        const system = this.household.systemID || this.$refs.waterSystem.value;

        if(system && system != "disabled")
        {
            const response = await this.$http.get(`/Asset?waterSystemId=${system}`);
            this.assets = response.data.assets;
        }
    },
    save: async function()
    {
        const tags = this.tags.slice();
        
        for(const tag of tags)
        {
            tag.nfcid = tag.nfcid.toUpperCase();
        }

        let body =
        {
            name: this.household.name,
            callingCode: this.callingCode,
            mobile: this.mobile,
            address: this.household.address,
            assetID: parseInt(this.$refs.asset.value),
            numberOfPeople: this.numberInHousehold,
            stats: this.household.stats,
            tags: tags
        }

        if(this.household.id)
        {
            body.householdID = this.household.id;
        }

        if(this.location)
        {
            body.latitude = this.location.latitude;
            body.longitude = this.location.longitude;
        }

        this.$refs.content.scrollTo(0, 0);

        try
        {
            const response = await this.$http.post(`/Household`, body);
            const user = this.user;
            user.householdID = response.data.householdID;
            user.assetID = response.data.assetID;
            user.systemID = response.data.systemID;
            this.user = user;

            this.notification =
            {
                show: true,
                className: "is-success",
                text: this.$t("Updated")
            }

            this.$router.push(
            {
                name: "Home",
                params:
                {
                    _persistNotification: true
                }
            });
        }

        catch(error)
        {
            if(error.response && error.response.status != 404)
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: error.response.data.message
                }
            }
            
            else
            {
                this.notification =
                {
                    show: true,
                    className: "is-danger",
                    text: this.$t("Error")
                }
            }
        }
    },
    next: async function()
    {
        switch(this.step)
        {
            case 1:
                try
                {
                    const response = await this.$http.get(`/Household/Available/${this.household.callingCode}${this.household.mobile}`);
                    this.household.id = response.data.household.householdID;
                    this.household.name = response.data.household.name;
                    this.household.address = response.data.household.address;
                    this.household.latitude = response.data.household.latitude;
                    this.household.longitude = response.data.household.longitude;
                    
                    if(response.data.household.stats)
                    {
                        this.household.stats = JSON.parse(response.data.household.stats);
                    }

                    this.household.systemID = response.data.household.systemID;
                    this.household.assetID = response.data.household.assetID;
                    this.tags = [];

                    for(const tag of response.data.household.tags)
                    {
                        this.tags.push(
                        {
                            nfcid: tag.nfcid,
                            name: tag.name,
                            callingCode: tag.callingCode,
                            mobile: tag.mobile
                        });
                    }

                    await this.updateTaps();
                }

                catch(error)
                {
                    if(error.response.status != 404)
                    {
                        this.notification =
                        {
                            show: true,
                            className: "is-danger",
                            text: error.response.data.message
                        }
                        return;
                    }
                }
                break;

            case 2:
                if(!this.$refs.name.checkValidity())
                {
                    this.$refs.name.reportValidity();
                    return;
                }
                break;
            
            case 4:
                if (this.$refs.waterSystem.selectedIndex == 0) {
                    this.$refs.waterSystem.selectedIndex = -1;
                }

                if(!this.$refs.waterSystem.checkValidity())
                {
                    this.$refs.waterSystem.reportValidity();
                    return;
                }

                if (this.$refs.asset.selectedIndex == 0) {
                    this.$refs.asset.selectedIndex = -1;
                }

                if(!this.$refs.asset.checkValidity())
                {
                    this.$refs.asset.reportValidity();
                    return;
                }
                break;

            case 5:
                this.numberInHousehold = 0;

                for(const key in this.household.stats)
                {
                    if(this.household.stats[key] == null)
                    {
                        this.household.stats[key] = 0;
                    }

                    this.numberInHousehold += this.household.stats[key];
                }

                if(this.numberInHousehold == 0)
                {
                    alert(this.$t("EnterNumberInHousehold"));
                    return;
                }
                break;
        }

        this.step++;
        this.$refs[`step${this.step-1}`].classList.add("is-hidden");
        this.$refs[`step${this.step}`].classList.remove("is-hidden");
    },
    back: function()
    {
        this.step--;
        this.$refs[`step${this.step}`].classList.remove("is-hidden");
        this.$refs[`step${this.step+1}`].classList.add("is-hidden");
    }
  }
};
</script>